import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { SettingsPaymentCreditContainer } from "@/components/features/settings/payment-credit";

import { useConfirmParams } from "./hooks";

export const SettingsPaymentCreditPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID } = result;

	return (
		<PageMeta title="お支払い情報" url={generatePath(PATHS.SETTINGS.PAYMENT_CREDIT, { hotelID })}>
			<SettingsPaymentCreditContainer hotelID={hotelID} />
		</PageMeta>
	);
};
